/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Package2, Users, CreditCard, PackageOpen } from "lucide-react";
import axios, { AxiosResponse } from "axios";
import Button from "../../shared/components/button/button";
import InputFieldComponent from "../../shared/components/forms/input-field/input-field";
import { SelectOptions } from "../../shared/interfaces/components/form.interface";
import nexumLogo from "../../assets/nexumLogo.png";
import CheckoutSelectComponent from "../../shared/components/forms/checkout-select/checkout-select-input";
import Sidebar from "../../shared/components/sidebar";
import Navbar from "../../shared/components/navbar";
import * as actions from "../../store/checkout/action";
import apiClient from "../../store/shared/api/apiClient";
import { ErroObj } from "../../shared/interfaces/model/errorObj.interface";
import { ApiErrorHandler } from "../../../errorHandler";
import {
  CheckoutParams,
  postCreateProductSubscription,
} from "../../store/checkout/api";
import MainLayout from "../../shared/components/MainLayout";
import Button2 from "../../shared/components/button/Button2";
import Loader from "../../shared/components/loader/Loader";
import { useProductStatus } from "../ProductList/hooks/useProductStatus";

interface CheckoutFields {
  numberOfUsers: number;
  tier: SelectOptions;
  subscriptionType: SelectOptions;
}
interface SelectOptionsField extends SelectOptions {
  name: keyof CheckoutFields;
}
const CheckoutPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { product } = location.state || {};
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const { productId: appCode } = useParams<{ productId: string }>();
  const tenantId = localStorage.getItem("tenantId");
  const [isLoading, setIsLoading] = useState(false);
  const [acquiredTier, setAcquiredTier] = useState<string>("");
  const [field, setFields] = useState<CheckoutFields>({
    numberOfUsers: 1,
    tier: { id: "0", value: "Select a version" },
    subscriptionType: { id: "0", value: "Select a plan" },
  });

  const { productStatuses } = useProductStatus();

  useEffect(() => {
    setAcquiredTier(product.desc);
    setButtonEnabled(
      // field?.tier?.id !== "0" &&
      field?.subscriptionType?.id !== "0"
    );
  }, [field]);

  const fieldHandler = (
    e: React.ChangeEvent<HTMLInputElement> | SelectOptionsField
  ) => {
    if ("id" in e && "value" in e) {
      setFields({ ...field, [e.name]: e } as CheckoutFields);
    } else {
      setFields({
        ...field,
        [e.target.name]: e.target.value,
      } as CheckoutFields);
    }
  };
  const refUser = useRef<HTMLInputElement>(null);
  const onSubmitHandler = async (action = "") => {
    // console.log("submit", field);
    try {
      setIsLoading(true);
      setFields({
        numberOfUsers: 1,
        tier: { id: "0", value: "Select a version" },
        subscriptionType: { id: "0", value: "Select a plan" },
      });
      const basePath = process.env.REACT_APP_ACTIVATION_URL;
      const body: CheckoutParams = {
        tenantId: `${tenantId ?? ""}`,
        tier: `${product.desc}`,
        subscription: `${field.subscriptionType.id}`,
        productId: product.appCode,
        // quantity: +field.numberOfUsers,
        quantity: 1,
        // domain: 'http://localhost:3000/private/checkoutPage/'
        domain: `https://${basePath}/private/checkoutPage/`,
        // domain: 'https://nexum-saas-portal.oa.r.appspot.com/private/checkoutPage/'
      };

      // console.log("body ====>", body);
      postCreateProductSubscription(body).then((response: any) => {
        const { url } = response.data;
        setButtonEnabled(true);
        // console.log("response ======>", response.data);
        if (url) {
          setIsLoading(false);
          window.location = url;
        }
      });
    } catch (error) {
      setIsLoading(false);
    }

    // /custom-subscription

    // const URL = `http://localhost:8080/custom-subscription?sessionId=${productId}`;
    // const URL = `http://localhost:8080/get-tenant?tenantId=${body.TenantId}`;
    // const URL = `http://localhost:8080/update-tenant?tenantId=${body.TenantId}`;
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const URL = `${baseUrl}/nexum-saas/productCheckout/?sessionId=${appCode}`;
    // let URL = `http://localhost:8080/`;

    // if (action === 'modify') {
    //   URL += `?update_subscription_id=${appCode}`;
    // } else if (action === 'delete') {
    //   URL += `?delete_subscription_id=sub_1OnpruH78uteNeFe0gQNSyk5`;
    // } else {
    //   URL += `?create_subscription_id=${appCode}`;
    // }

    // apiClient
    //   .post(URL, body, {
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //   })
    //   .then((response: AxiosResponse) => {
    //     // if (action === 'delete') {
    //     //   console.log("response ======>", response.data);
    //     //   return;
    //     // }
    //     const { url } = response.data;
    //     setButtonEnabled(true);
    //     console.log("response ======>", response.data);
    //     if (url) window.location = url;
    //   })
    //   .catch((e: ErroObj) => {
    //     ApiErrorHandler(
    //       e.message,
    //       e.config.url,
    //       JSON.stringify(e.config.headers),
    //       e.config.method
    //     );
    //   });
  };
  return (
    <MainLayout>
      <Loader isLoading={isLoading} />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
      >
        <div className="max-w-4xl mx-auto">
          <motion.div
            className="bg-white rounded-2xl shadow-xl overflow-hidden"
            whileHover={{ scale: 1.01 }}
            transition={{ duration: 0.2 }}
          >
            <div className="grid md:grid-cols-2">
              {/* Left Side - Logo */}
              <div className="p-8 bg-gradient-to-br from-sky-200 to-white flex items-center justify-center ">
                <img
                  className="max-w-[200px] w-full"
                  src={nexumLogo}
                  alt="nexumLogo"
                />
              </div>

              {/* Right Side - Form */}
              <div className="p-8">
                <div className="space-y-6">
                  <div>
                    <h1 className="text-2xl font-bold text-gray-900">
                      Purchase a product
                    </h1>
                    <p className="mt-2 text-sm text-gray-600">
                      Select the desired configuration
                    </p>
                  </div>

                  <form className="space-y-6">
                    {/* Product Name Field */}

                    <div className="flex  space-x-2 flex-col">
                      <label className="text-sm font-medium text-gray-700 flex items-center flex-row pl-2 mb-2">
                        <PackageOpen className="w-5 h-5 text-green-500 mr-2" />
                        Product Name:
                      </label>
                      <InputFieldComponent
                        data-test="productName"
                        name="productName"
                        id="productName"
                        type="text"
                        label=""
                        value={product?.name}
                        title="Inserire campo"
                        disabled
                        className="w-full rounded-lg border-sky-300 min-h-[45px] focus:border-sky-500 focus:ring-sky-500"
                        onChangeHandler={() => {
                          return;
                        }}
                      />
                    </div>

                    {/* Tier Field */}
                    <div className="flex  space-x-2 flex-col">
                      <label className="text-sm font-medium text-gray-700 flex items-center flex-row pl-2 mb-2">
                        <Package2 className="w-5 h-5 text-green-500 mr-2" />
                        Version:
                      </label>
                      <InputFieldComponent
                        data-test="tier"
                        id="tier"
                        name="tier"
                        label=""
                        type="text"
                        value={product.desc}
                        placeholder="Select a version"
                        required={false}
                        title="Tier selezionato"
                        disabled
                        onChangeHandler={() => {
                          return;
                        }}
                        className="w-full rounded-lg border-sky-300 min-h-[45px] focus:border-sky-500 focus:ring-sky-500"
                      />
                    </div>

                    {/* Subscription Type Field */}

                    <div className="flex  space-x-2 flex-col">
                      <label className="text-sm font-medium text-gray-700 flex items-center flex-row pl-2 mb-2">
                        <CreditCard className="w-5 h-5 text-green-500 mr-2" />
                        Subscription Type:
                      </label>
                      <CheckoutSelectComponent
                        id="subscriptionType"
                        label=""
                        options={[
                          { id: "0", value: "Select a subscription type" },
                          {
                            id: "Monthly",
                            value: "Monthly",
                            ...(productStatuses[product.appCode]?.paidDetails
                              ?.payment
                              ? {
                                  disabled:
                                    productStatuses[product.appCode]
                                      ?.paidDetails?.payment !== "Monthly",
                                }
                              : {}),
                          },
                          {
                            id: "Annually",
                            value: "Annual",
                            ...(productStatuses[product.appCode]?.paidDetails
                              ?.payment
                              ? {
                                  disabled:
                                    productStatuses[product.appCode]
                                      ?.paidDetails?.payment !== "Annually",
                                }
                              : {}),
                          },
                        ]}
                        placeholder="Select a subscription type"
                        value={field.subscriptionType}
                        name="subscriptionType"
                        required
                        onChangeHandler={(data) =>
                          fieldHandler({
                            ...data,
                            name: "subscriptionType",
                          })
                        }
                        className="w-full rounded-lg min-h-[45px] border-sky-300 focus:border-sky-500 focus:ring-sky-500"
                      />
                    </div>

                    {/* Hidden Number of Users Field */}
                    <div className="form-group" style={{ display: "none" }}>
                      <InputFieldComponent
                        data-test="numberOfUsers"
                        name="numberOfUsers"
                        id="numberOfUsers"
                        type="number"
                        label="Numero utenti:"
                        value={field?.numberOfUsers}
                        title="Inserire campo"
                        ref={refUser}
                        required={false}
                        onChangeHandler={fieldHandler}
                      />
                    </div>

                    {/* Enterprise Tier Specific Fields */}
                    {acquiredTier === "Enterprise" ? (
                      <>
                        {!localStorage.getItem("isUser") ||
                        localStorage.getItem("isUser") !== "true" ? (
                          <div className="space-y-2">
                            <div className="flex items-center space-x-2">
                              <Users className="w-5 h-5 text-sky-500" />
                              <InputFieldComponent
                                data-test="numberOfUsers"
                                name="numberOfUsers"
                                id="numberOfUsers"
                                type="number"
                                label="Numero utenti:"
                                value={field?.numberOfUsers}
                                title="Inserire campo"
                                ref={refUser}
                                required={false}
                                min={0}
                                onChangeHandler={fieldHandler}
                                className="w-full rounded-lg border-sky-300 focus:border-green-500 focus:ring-green-500"
                              />
                            </div>
                          </div>
                        ) : null}

                        <motion.div whileTap={{ scale: 0.95 }} className="pt-4">
                          <Button2
                            title="Checkout"
                            onClick={() => onSubmitHandler()}
                            disabled={false}
                            className="w-full bg-[#17398a] hover:bg-sky-500 transition-all text-white font-semibold py-3 rounded-lg disabled:opacity-70 disabled:cursor-not-allowed"
                          />
                        </motion.div>
                      </>
                    ) : (
                      <motion.div whileTap={{ scale: 0.95 }} className="pt-4">
                        <Button2
                          title="Checkout"
                          onClick={() => onSubmitHandler()}
                          disabled={!buttonEnabled}
                          className="w-full bg-[#17398a] hover:bg-sky-500 text-white transition-all font-semibold py-3 rounded-lg disabled:opacity-70 disabled:cursor-not-allowed"
                        />
                      </motion.div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </MainLayout>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getCheckoutRequest: (payload?: object) => {
    dispatch(actions.getCheckoutRequest(payload));
  },
});
export default connect(mapDispatchToProps)(CheckoutPage);
